import {isSemUser} from '../../modules/tracking';
import {triggerClickOutAction} from '../analytics/cta-events';

const formatPhoneNumberWithDashes = (phone) => {
    phone = phone.replace(/\D/g, '')
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
}

/*
*   passing in param will grab the phone number from the sibling or the entire page
*   checks sibling by default
*
*   @param bool updateAllBuyflows
*/

// Append S3 Values on Buyflow Click
export function appendBuyFlowParams () {
    const BUYFLOW_SELECTOR = '[data-ga="referral-cta"]';

    // Handle buyflow links Clicks
    function handleBuyFlowLinkClicks(event, $buyFlowButton, buyFlowData)
    {
        let showPrettyLink = (event.type === 'mouseenter' || event.type === 'hover' || event.type === 'touchmove');
        let redirectUrl = $buyFlowButton.getAttribute('href');
        let phoneNumber = buyFlowData['phoneNumber'] || null;

        return new Promise((resolve) => {

            if (showPrettyLink) {
                // Debugging
                console.log('Pretty Link found, Handling Pretty Link replacement...');
                handlePrettyLinkReplacements($buyFlowButton, showPrettyLink);
            }

            if (phoneNumber) {
                let newPhoneNumber = formatPhoneNumberWithDashes(phoneNumber);
                // Debugging
                console.log('Updating buyflow link with new phone number:', newPhoneNumber);

                redirectUrl = updateBuyFlowLink($buyFlowButton, newPhoneNumber);
            }

            return resolve(redirectUrl);
        });
    }

    // Handle pretty link replacements
    function handlePrettyLinkReplacements(button, showPrettyLink = false) {
        const pretty = button.getAttribute('data-pretty');
        const clickoutLink = button.getAttribute('href');

        if (showPrettyLink && pretty) {
            button.setAttribute('href', pretty);
        } else {
            button.setAttribute('href', clickoutLink);
        }
    }


    // Get the ringpool and pretty link data attributes from the buyflow button
    function getBuyFlowButtonDataAttributes($buyFlowButton)
    {
        let results = {},
            overrideTfn = '',
            tfn = '',
            tfnFallback = '',
            tfnAltFallback = '',
            phoneNumber = '';

        if ($buyFlowButton) {
            const productId = $buyFlowButton.getAttribute('data-product-id') || '';
            const tfnDataElement = document.querySelector(`[data-phone-product-id="${productId}"]`);
            if (tfnDataElement) {
                overrideTfn = tfnDataElement.dataset.phoneOverride;
                tfn = tfnDataElement.dataset.ringpoolType2;
                tfnFallback = tfnDataElement.dataset.ringpoolFallback;
                if (isSemUser()) {
                    tfnAltFallback = tfnDataElement.dataset.ringpoolAltFallback;
                }
            }

            if (overrideTfn) {
                phoneNumber = overrideTfn;
            } else if (tfn) {
                phoneNumber = tfn;
            } else if (tfnAltFallback) {
                phoneNumber = tfnAltFallback;
            } else if (tfnFallback) {
                phoneNumber = tfnFallback;
            }

            results['ringpoolId'] = $buyFlowButton.getAttribute('data-ringpoolid') || '';
            results['phoneNumber'] = phoneNumber;
            results['openInNewTab'] = $buyFlowButton.getAttribute('target') === '_blank';
        }

        // Debugging
        console.log('Getting buyflow and pretty link data attributes:', results);
        return results;
    }

    // Update the buyflow link with s3 values
    function updateBuyFlowLink(buyFlowButton, phoneNumber) {
        const s3Value = phoneNumber || '';
        const baseUrl = buyFlowButton.getAttribute('href');

        if (!baseUrl) return '';

        const buyFlowUrl = new URL(baseUrl, window.location.origin);
        const params = new URLSearchParams(buyFlowUrl.search);

        if (s3Value) {
            params.set('s3', s3Value);
            buyFlowUrl.search = params.toString();
        }

        return buyFlowUrl.toString();
    }


    // Redirect user to buyFlow URL
    function redirectToBuyFlowUrl(redirectUrl, openInNewTab = false)
    {
        if (openInNewTab) {
            window.open(redirectUrl, '_blank');
        } else {
            window.location.href = redirectUrl;
        }
    }

    ['click', 'touchstart', 'contextmenu', 'auxclick', 'mouseover', 'mouseenter', 'touchmove'].forEach(eventType => {
        document.body.addEventListener(eventType, handleBuyflowEvent, true);
    });

    function handleBuyflowEvent(event) {
        const target = event.target.closest(BUYFLOW_SELECTOR);
        if (!target) return;

        const buyFlowData = getBuyFlowButtonDataAttributes(target);
        const ringpoolId = buyFlowData['ringpoolId'] || -1;
        let shouldRedirect = false;

        if (event.button === 2) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        if (
            event.type === 'click' ||
            event.type === 'auxclick' ||
            (event.type === 'contextmenu' && event.button === 2) ||
            event.type === 'touchstart'
        ) {
            shouldRedirect = true;
        }

        if (shouldRedirect) {
            handleBuyFlowLinkClicks(event, target, buyFlowData)
                .then((redirectUrl) => {
                    console.log('handleBuyFlowLinkClicks completed, Redirect URL:', redirectUrl);
                    console.log('Redirecting to buyflow link...', redirectUrl);
                    triggerClickOutAction(target);
                    redirectToBuyFlowUrl(redirectUrl, buyFlowData['openInNewTab']);
                })
                .catch((error) => {
                    console.error('Error handling buyflow link click:', error);
                });
        } else {
            handlePrettyLinkReplacements(target, true);
            console.log('Preparing ringpool reservation for child page...', ringpoolId);
        }
    }
}

export default function init() {
    appendBuyFlowParams();
}
